<template>
  <div class="kf-header">
    <div class="kf-header-menu-icon" @click="handleBack">
      <!--    <i class="iconfont icon-kingfisherLOGO-copy ml10 " ></i>-->
      <img src="../../../styles/img/header/kf-logo.png" class="kf-logo ml10">
    </div>
    <div class="kf-user-box mr16">
      <el-dropdown @command="doClickChange">
                    <span class="el-dropdown-link">
                  <div class="right-content_box"><!--<img src="../../../styles/img/header/user.png" style="margin-right: 8px">-->
                      <i class="iconfont icon-a-yonghutouxiangbeifen1"
                         style="margin-right: 10px;font-size: 17px"></i>{{ loginUserInfo.userName }}</div>
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item v-for="(item,index) in options"
                              :key="index"
                              :command="item"
            >{{ item.name }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import {computed, onMounted, ref, nextTick} from 'vue'
import userModel from '@/model/user'
import menuModel from '@/model/menu'

export default {
  name: "kf-Header",
  setup() {
    userModel.checkout({ callback: (code, msg) => {
        if (code === 0) {
          localStorage.setItem('KC_USER', JSON.stringify(userModel.user.value));
          localStorage.setItem('KC_TOKEN', msg);
        } else {
          localStorage.setItem('KC_USER', '');
          localStorage.setItem('KC_TOKEN', '');
          router.replace({path: '/'});
        }
      }, errCatch: (err) => {
        localStorage.setItem('KC_USER', '');
        localStorage.setItem('KC_TOKEN', '');
        router.replace({path: '/'});
      }
    });

    let loginUserInfo = ref({});
    const options = ref([
      {name: "退出登录", code: "01"},
    ]);
    if (userModel.user === undefined || userModel.user.userName === undefined) {
      loginUserInfo.value = JSON.parse(localStorage.getItem('KC_USER'));
    } else {
      loginUserInfo.value = userModel.user;
    }

    const doClickChange = function (val) {
      if (val.code === "01") {
        localStorage.setItem('KC_USER', JSON.stringify({}));
        userModel.updateUser({});
        userModel.logout()
        router.replace({path: '/'});
      }
    }

    const handleBack = function () {
      menuModel.updateCurrMenu({});
    }

    return {
      loginUserInfo,
      options,
      doClickChange,
      handleBack
    }
  }
}
</script>

<style scoped>

</style>